













import Vue from 'vue';

interface IMenuItem {
  name: string;
  to: string;
}

export default Vue.extend({
  data() {
    return {
      menuItems: [{
        name: '貨品',
        to: '/products',
      }, {
        name: '預設標籤',
        to: '/presettags',
      }, {
        name: '團期',
        to: '/batches',
      }] as IMenuItem[],
    };
  },
  computed: {
    noMenu(): boolean {
      return this.$route.meta.noMenu === true ? true : false;
    },
  },
  methods: {
    gotoPath(menuItem: IMenuItem) {
      this.$router.push(menuItem.to);
    },
  },
});
